<div class="header">
  <div>
    <h2>{{ 'pages.admin.learners.title' | translate }}</h2>
  </div>
</div>

<div class="search">
  <nb-form-field>
    <input
      type="text"
      nbInput
      fullWidth
      [placeholder]="'menu.searchPlaceholder' | translate"
      [(ngModel)]="searchText"
      (ngModelChange)="resetPage()"
    />
    <button nbSuffix nbButton ghost>
      @if (searchText && searchText.length > 0) {
        <nb-icon icon="close-outline" (click)="searchText = ''"></nb-icon>
      } @else {
        <nb-icon icon="search-outline" pack="eva"></nb-icon>
      }
    </button>
  </nb-form-field>
  <button
    nbButton
    ghost
    size="small"
    status="basic"
    [disabled]="!hasActiveFilters()"
    (click)="clearFilters()"
  >
    Filter zurücksetzen
  </button>
</div>

<nb-card>
  <nb-card-body>
    <app-page-loader *ngIf="isLoading"></app-page-loader>

    <div *ngIf="!isLoading && filteredLearners.length === 0" class="empty-state">
      <p>{{ 'pages.admin.learners.empty' | translate }}</p>
    </div>

    <table *ngIf="!isLoading && filteredLearners.length > 0" class="learners-table">
      <colgroup>
        <col style="width: 13%" />
        <col style="width: 14%" />
        <col style="width: 10%" />
        <col style="width: 7%" />
        <col style="width: 24%" />
        <col style="width: 12%" />
        <col style="width: 12%" />
        <col style="width: 6%" />
      </colgroup>
      <thead>
        <tr>
          <th>
            <button type="button" class="sort-button" (click)="toggleSort('name')">
              <span>{{ 'input.name.label' | translate }}</span>
              <nb-icon [icon]="sortIcon('name')"></nb-icon>
            </button>
          </th>
          <th>
            <button type="button" class="sort-button" (click)="toggleSort('email')">
              <span>{{ 'input.email.label' | translate }}</span>
              <nb-icon [icon]="sortIcon('email')"></nb-icon>
            </button>
          </th>
          <th>
            <button type="button" class="sort-button" (click)="toggleSort('user_id')">
              <span>User ID</span>
              <nb-icon [icon]="sortIcon('user_id')"></nb-icon>
            </button>
          </th>
          <th>
            <button type="button" class="sort-button" (click)="toggleSort('source')">
              <span>{{ 'pages.admin.learners.source' | translate }}</span>
              <nb-icon [icon]="sortIcon('source')"></nb-icon>
            </button>
          </th>
          <th>
            <button type="button" class="sort-button" (click)="toggleSort('client')">
              <span>{{ 'pages.admin.learners.client' | translate }}</span>
              <nb-icon [icon]="sortIcon('client')"></nb-icon>
            </button>
          </th>
          <th>
            <button type="button" class="sort-button" (click)="toggleSort('created_at')">
              <span>{{ 'pages.admin.learners.createdAt' | translate }}</span>
              <nb-icon [icon]="sortIcon('created_at')"></nb-icon>
            </button>
          </th>
          <th>
            <button type="button" class="sort-button" (click)="toggleSort('last_active_at')">
              <span>{{ 'pages.admin.learners.lastActive' | translate }}</span>
              <nb-icon [icon]="sortIcon('last_active_at')"></nb-icon>
            </button>
          </th>
          <th></th>
        </tr>
        <tr class="filter-row">
          <th>
            <input nbInput fullWidth fieldSize="tiny" placeholder="Name" [(ngModel)]="filters.name" (ngModelChange)="resetPage()" />
          </th>
          <th>
            <input nbInput fullWidth fieldSize="tiny" placeholder="E-Mail" [(ngModel)]="filters.email" (ngModelChange)="resetPage()" />
          </th>
          <th>
            <input nbInput fullWidth fieldSize="tiny" placeholder="User ID" [(ngModel)]="filters.user_id" (ngModelChange)="resetPage()" />
          </th>
          <th>
            <nb-select fullWidth size="tiny" placeholder="Alle" [(selected)]="filters.source" (selectedChange)="resetPage()">
              <nb-option value="">Alle</nb-option>
              <nb-option *ngFor="let source of sourceOptions" [value]="source">{{ source }}</nb-option>
            </nb-select>
          </th>
          <th>
            <input nbInput fullWidth fieldSize="tiny" placeholder="Mandant" [(ngModel)]="filters.client" (ngModelChange)="resetPage()" />
          </th>
          <th>
            <input nbInput fullWidth fieldSize="tiny" placeholder="Datum" [(ngModel)]="filters.created_at" (ngModelChange)="resetPage()" />
          </th>
          <th>
            <input nbInput fullWidth fieldSize="tiny" placeholder="Datum" [(ngModel)]="filters.last_active_at" (ngModelChange)="resetPage()" />
          </th>
          <th></th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let l of pagedLearners; trackBy: trackLearner">
          <td class="clickable-name" (click)="openProfile(l)">
            {{ getName(l) }}
            <nb-icon icon="person-outline" class="profile-icon"></nb-icon>
          </td>
          <td>{{ l.email ?? '—' }}</td>
          <td class="user-id-cell" [title]="l.user_id ?? ''">{{ l.user_id ? l.user_id.substring(0, 8) + '…' : '—' }}</td>
          <td>
            <span class="inline-badge">{{ l.source ?? '—' }}</span>
          </td>
          <td>
            <div class="client-cell">
              <span class="client-name">{{ l.client_name }}</span>
              <span class="client-email">{{ l.client_email }}</span>
              <span class="client-id">{{ l.client_id }}</span>
            </div>
          </td>
          <td>{{ l.created_at ? (l.created_at | date: 'short') : '—' }}</td>
          <td>{{ l.last_active_at ? (l.last_active_at | date: 'short') : '—' }}</td>
          <td>
            <button nbButton ghost size="tiny" status="primary" (click)="openProfile(l)">
              <nb-icon icon="eye-outline"></nb-icon>
            </button>
          </td>
        </tr>
      </tbody>
    </table>

    <app-pagination
      *ngIf="!isLoading && filteredLearners.length > 0"
      [totalItems]="filteredLearners.length"
      [itemsPerPage]="pageSize"
      [currentPage]="currentPage"
      [pageSizeOptions]="pageSizeOptions"
      (pageChanged)="onPageChange($event)"
      (itemsPerPageChange)="onPageSizeChange($event)"
    ></app-pagination>
  </nb-card-body>
</nb-card>
